import React, { ReactNode } from 'react';
import { Box, Button } from '@mui/material';
import { Typography } from 'src/components/new/Typography';

interface SectionProps {
  title: string;
  content: any;
  icon: any;
  isEditable?: boolean;
  onEdit: () => void;
  editLabel?: string;
  headerTooltip?: ReactNode;
}

const Section: React.FunctionComponent<SectionProps> = ({ title, content, isEditable, onEdit, headerTooltip, editLabel = 'Edit' }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Box>
      <Box sx={{display: 'flex', alignItems: 'center', gap: '0.625rem', marginBottom: '0.3125rem',}}>
          <Typography
            sx={{
              fontSize: '0.8125rem',
              fontWeight: '400',
            }}
          >
            {title}
          </Typography>
          {headerTooltip}
        </Box>
        {content.map((line: any, index: any) => (
          <Typography key={index} fontWeight={500} sx={{ fontSize: '1.375rem', lineHeight: '1.75rem', }}>
            {line}
          </Typography>
        ))}
      </Box>
      {isEditable && (
        <Button
          onClick={onEdit}
          sx={{
            alignSelf: 'flex-start',
            textTransform: 'capitalize',
            fontWeight: 'bold',
            background: '#EDEDED',
            width: '11.875rem',
            color: '#1D1B20',
          }}
        >
          {editLabel}
        </Button>
      )}
    </Box>
  );
};

export default Section;
